import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d5e369b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2d5e369b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e369b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5e369b')) {
      api.createRecord('2d5e369b', component.options)
    } else {
      api.reload('2d5e369b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d5e369b&scoped=true&", function () {
      api.rerender('2d5e369b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/famousPerson/commentMent/index.vue"
export default component.exports